import styled from "styled-components"

import { color } from "../../../atoms/colors"
import quoteAfter from "../../../images/icons/quote-end.svg"
import quoteBefore from "../../../images/icons/quote-start.svg"

export const TestimonialSliderStyles = styled.div`
  padding-top: 48px;

  position: relative;
  &.bg-sprite {
    .eyebrow {
      border: 2px solid ${color.oxfordBlue[600]} !important;
      color: ${color.oxfordBlue[600]} !important;
    }
  }
  &.bg-plum {
    .heading {
      color: ${color.common.white} !important;
    }
  }
  .heading-container {
    text-align: center;
    margin: 0 auto;
    .eyebrow {
      font-size: 14px;
      font-weight: 500;
      border: 2px solid ${color.secondary[600]};
      border-radius: 40px;
      padding: 7px 15px 3px;
      display: inline;
      line-height: 1em;
      display: inline-block;
      margin-bottom: 24px;
      color: ${color.secondary[600]};
    }
    .heading {
      color: ${color.oxfordBlue[900]};
      margin-bottom: 20px;
    }
    .description {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 28px;
    }
  }
  .swiperImg {
    .swiper {
      padding: 20px;
    }
    .swiper-slide {
      width: 100% !important;
      background: ${color.common.white};
      box-shadow: 0px 0px 20px rgba(106, 114, 158, 0.1);
      .img-wrapper {
        img {
          max-width: 200px;
          filter: brightness(0) invert(1);
          object-fit: contain;
          object-position: center;
        }
      }
      .media {
        img {
          width: 100%;
          object-fit: cover;
          object-position: center;
        }
        background: ${color.copy[100]};
      }
      .item-desc {
        padding: 1.5rem;
      }
    }
    .swiper-button-prev {
      position: absolute;
      top: calc(50%);
      left: 0;
      line-height: 36px;
      text-align: center;
      border-radius: 50%;
      display: inline-block;
      transition: all 450ms ease-in-out;
      width: 36px;
      height: 36px;
      background: ${color.copy[50]};
      box-shadow: 0px 0px 20px rgba(106, 114, 158, 0.1);
      &:hover {
        background-color: ${color.primary[500]} !important;
        &:after {
          color: ${color.common.white};
        }
      }
      &:after {
        font-size: 14px;
        line-height: 36px;
        color: ${color.common.black};
        font-weight: 700;
      }
      @media (max-width: 991.98px) {
        display: none;
      }
    }
    .swiper-button-next {
      position: absolute;
      top: calc(50%);
      right: 0;
      line-height: 36px;
      text-align: center;
      border-radius: 50%;
      display: inline-block;
      transition: all 450ms ease-in-out;
      width: 36px;
      height: 36px;
      background: ${color.copy[50]};
      box-shadow: 0px 0px 20px rgba(106, 114, 158, 0.1);
      &:hover {
        background-color: ${color.primary[500]} !important;
        &:after {
          color: ${color.common.white};
        }
      }
      &:after {
        font-size: 14px;
        line-height: 36px;
        color: ${color.common.black};
        font-weight: 700;
      }
      @media (max-width: 991.98px) {
        display: none;
      }
    }
  }
  .swipernoImg {
    .swiper {
      background-color: ${color.aliceBlue[50]};
      padding: 40px;
    }
    .swiper-slide {
      width: 100% !important;
      background: ${color.common.transparent};
      .item-desc {
        padding: 1.5rem;
        font-weight: 400;
        font-style: normal;
        font-size: 28px;
        line-height: 35px;
        color: ${color.copy[900]};
        @media (max-width: 991.98px) {
          padding: 0;
        }
        .description {
          position: relative;
          &::before {
            content: "";
            width: 16px;
            height: 11px;
            background-image: url(${quoteBefore});
            background-repeat: no-repeat;
            background-position: left top;
            display: inline-block;
            vertical-align: text-top;
            margin-right: 8px;
          }
          &::after {
            content: "";
            width: 16px;
            height: 11px;
            background-image: url(${quoteAfter});
            background-repeat: no-repeat;
            background-position: left top;
            display: inline-block;
            vertical-align: super;
            margin-left: 8px;
          }
        }
        .author {
          font-size: 16px;
          line-height: 24px;
        }
        @media (max-width: 991.98px) {
          font-size: 14px;
        }
      }
    }
    .swiper-button-prev {
      position: absolute;
      top: calc(90%);
      left: auto;
      right: 80px;
      line-height: 26px;
      text-align: center;
      border-radius: 50%;
      display: inline-block;
      transition: all 450ms ease-in-out;
      width: 26px;
      height: 26px;
      background-color: ${color.oxfordBlue[800]};
      box-shadow: 0px 0px 20px rgba(106, 114, 158, 0.1);
      &:hover {
        background-color: ${color.primary[500]} !important;
        &:after {
          color: ${color.common.white};
        }
      }
      &:after {
        font-size: 10px;
        line-height: 26px;
        color: ${color.common.white};
        font-weight: 700;
      }
      @media (max-width: 991.98px) {
        display: none;
      }
    }
    .swiper-button-next {
      position: absolute;
      top: calc(90%);
      left: auto;
      right: 45px;
      line-height: 26px;
      text-align: center;
      border-radius: 50%;
      display: inline-block;
      transition: all 450ms ease-in-out;
      width: 26px;
      height: 26px;
      background-color: ${color.oxfordBlue[800]};
      box-shadow: 0px 0px 20px rgba(106, 114, 158, 0.1);
      &:hover {
        background-color: ${color.primary[500]} !important;
        &:after {
          color: ${color.common.white};
        }
      }
      &:after {
        font-size: 10px;
        line-height: 26px;
        color: ${color.common.white};
        font-weight: 700;
      }
      @media (max-width: 991.98px) {
        display: none;
      }
    }
  }
`
